<template>
    <div class="templateOxy">
        <div class="glass text-center">
        
         <div class="title">
                  <h3>အောက်ဆီဂျင်</h3>
                  <h5> ဘယ်လောက်ထားရမလဲ</h5>
              </div>
     
            <div class="col-md-5 mx-auto d-block form">
                  <form @submit.prevent ="result">

                     <div class="mb-3 p-2">
                        <label for="lvlSelect" class="mb-2"> သွေးတွင်းအောက်ဆီဂျင် level ထည့်ရန် (sp02)</label>
                          <input type="number" class="form-control p-2 text-center" v-model="oxyRate">
                     </div>

                      <button class="btn btn-success p-2 mt-3" type="submit"> တွက်မယ် </button>
                  </form>
          </div>

          <div class="answer p-2">
               <h3 > {{ data }} </h3>
          </div>
        </div>

  </div>




</template>

<script>
export default {
  name: "Oxylvl",

  data() {
    return {
        oxyRate : '',
        data: '' ,

    };
  },

  methods : {
 
      result() {
        var data1 = ( 94 - this.oxyRate ) /4 ;
        var data2 = Math.round(data1);

        if ( data2 >= 10) {
          this.data =  "Flow Rate level ( " +  10  +" )  တွင်ထားရန်";
        }

        else {
             this.data = "Flow Rate level  ( "+ data2 +" ) တွင်ထားရန်"  ;
        }

       
      }

    }

    
  }



</script>

<style>
  .templateOxy {
          min-height: 100vh;
          background:linear-gradient(to right top, #a2ffcc, #e2e8e9);
          display: flex;
          align-items: center;
          justify-content: center;
          
          
        }
</style>